import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../../Tenants";
import { AddUserBtn } from "@/App/Users/UsersTenant/Add";
import { ComponentTableUsers } from "@/App/Users/UsersTenant/Table";
import { getUsersTenantData, searchUserTenantData } from "@/Api/usersTenant";
import { TypeUsersProp } from "..";
import { TypePageActions } from "@/pages/Plans";
import { useAuth } from "@/hooks/auth";
import { NotFound } from "@/pages/NotFound";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";

export const UsersTenantPage = ({ tenant_uuid }) => {
  const auth = useAuth();
  if (
    tenant_uuid !== auth?.user?.tenant?.uuid &&
    (auth?.user?.user_type_id !== 1 || auth?.user?.user_type_id !== 2)
  )
    return <NotFound />;

  const [usersData, setUsersData] = useState({} as ApiDataProps<TypeUsersProp>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();

  // inicio: pegando dados da api e setando em variavel de estado
  useEffect(() => {
    (async () => {
      const { data } = await getUsersTenantData({ tenant_uuid });
      // console.log(data?.response);
      setUsersData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (usersData?.current_page < usersData?.last_page) {
        setState("loading");

        const { data } = await getUsersTenantData({
          tenant_uuid,
          page: usersData?.current_page + 1,
        });
        setUsersData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (usersData?.current_page > 1) {
        setState("loading");

        const { data } = await getUsersTenantData({
          tenant_uuid,
          page: usersData?.current_page - 1,
        });
        setUsersData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (usersData?.current_page !== usersData?.last_page) {
        setState("loading");

        const { data } = await getUsersTenantData({
          tenant_uuid,
          page: usersData?.last_page,
        });
        setUsersData(data?.response);
        // console.log(data);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-users-list")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          {auth?.user?.user_type_id === 1 ? (
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <Link
                    to={"/empresas"}
                    className={cn("transition-colors hover:text-foreground")}
                  >
                    Instituições
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>
                    {usersData && usersData?.data?.[0]?.tenant?.name}
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          ) : (
            <h2 className="text-2xl font-semibold flex gap-2 items-center">
              Usuários
            </h2>
          )}
          <If condition={hasPermission("create-user")}>
            <AddUserBtn updateFront={setUsersData} tenantUuid={tenant_uuid} />
          </If>
        </div>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setUsersData}
            setState={setState}
            funcSearch={({ name }) =>
              searchUserTenantData({ tenant_uuid, name })
            }
            placeholder="Pesquisar usuário"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <ComponentTableUsers
              dataApi={usersData}
              pageActions={pageActions}
              updateFront={setUsersData}
              tenantUuid={tenant_uuid}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
